// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"_25d45facb5--backdrop--QXKY1"};